export default __webpack_public_path__ + "static/media/s1.be51b5c7.jpeg";